import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(theme => ({
  root: {
    flexDirection: "row",
    justifyContent: props => (props.center ? "norma" : "flex-end"),
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
      flexDirection: "column",
      textAlign: "end"
    }
  },
  image: {
    height: theme.spacing(10),
    width: theme.spacing(10),
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    filter: "grayscale(1)",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(0)
    }
  }
}));

export default function TextImage({ center, image, text }) {
  const classes = useStyles({ center });

  if (!image) return text;

  return (
    <Box className={classes.root} display="flex">
      <div
        style={{ backgroundImage: `url(${image})` }}
        className={classes.image}
      />
      <span>{text}</span>
    </Box>
  );
}
